import { components } from '@api/club/generated';

import {
  ITournamentForStates,
  useTournamentStates,
} from '@features/tournament/hooks/useTournamentStates';

export type ITournamentForParticipantState = ITournamentForStates & {
  joinEligibility: components['schemas']['ParticipantJoinEligibility'];
};

export function useTournamentParticipantState(tournament?: ITournamentForParticipantState | null) {
  const { isJoinable, isLeavable } = useTournamentStates(tournament);

  return {
    hasJoined: tournament?.joinEligibility === 'Joined',
    isBeingPreModerated: tournament?.joinEligibility === 'Pending',
    canLeave: isLeavable && tournament?.joinEligibility === 'Joined',
    canJoin: isJoinable && tournament?.joinEligibility === 'CanJoin',
    canJoinWithTicket: isJoinable && tournament?.joinEligibility === 'NoTicket',
  };
}
